export default {
  computed: {
    toolsRoutes() {
      return {
        tools: {
          name: "tools",
          title: "Ferramentas"
        },
        "tools-webhook": {
          name: "tools-webhook",
          title: "Webhook (API e notificações)"
        },
        "tools-coproductions": {
          name: "tools-coproductions",
          title: "Coproduções"
        },

        "tools-email-marketing": {
          name: "tools-email-marketing",
          title: "Email marketing"
        },

        "tools-automations": {
          name: "tools-automations",
          title: "Automações"
        },
        "tools-voxuy": {
          name: "tools-voxuy",
          title: "Voxuy"
        },
        "tools-conta-azul": {
          name: "tools-conta-azul",
          title: "Conta Azul"
        },
        "tools-utmify": {
          name: "tools-utmify",
          title: "Utmify"
        },

        "tools-invoices": {
          name: "tools-invoices",
          title: "Notas fiscais"
        },

        "tools-member-area": {
          name: "tools-member-area",
          title: "Área de membros"
        },

        "tools-google-ads": {
          name: "tools-google-ads",
          title: "Google Ads"
        },

        "tools-google-analytics": {
          name: "tools-google-analytics",
          title: "Google Analytics"
        },

        "tools-facebook-ads": {
          name: "tools-facebook-ads",
          title: "Facebook Ads"
        },

        "tools-kwai-ads": {
          name: "tools-kwai-ads",
          title: "Kwai Ads"
        },

        "tools-mec-certifications": {
          name: "tools-mec-certifications",
          title: "Certificações MEC"
        }
      };
    }
  }
};
